import { queryOptions } from '@tanstack/react-query';

import { queryKeys } from '@/hooks/api/query-keys';

import { getTeamDetails, getTeamMembers } from './team-settings-server';

export function teamDetailsQueryOptions(teamId: string) {
  return queryOptions({
    queryKey: [...queryKeys.workspaceSettings.team(teamId), 'details'],
    queryFn: () => getTeamDetails(),
  });
}

export function teamMembersQueryOptions(teamId: string) {
  return queryOptions({
    queryKey: [...queryKeys.workspaceSettings.team(teamId), 'members'],
    queryFn: () => getTeamMembers({ data: { teamId } }),
  });
}
